import type {Expense} from './types';

const normalize=(text:string)=>text.toLocaleLowerCase().replace(/[\s\p{P}\p{S}]+/gu,'');

const clues:[string,RegExp][]=[
 ['住宿',/飯店|旅館|民宿|住宿|房費|hotel|hostel|airbnb/i],
 ['交通',/機票|車票|地鐵|捷運|巴士|公車|計程車|交通|高鐵|火車|新幹線|uber|taxi|train|metro|flight/i],
 ['餐飲',/早餐|午餐|晚餐|宵夜|咖啡|甜點|餐廳|拉麵|燒肉|飲料|便當|美食|coffee|cafe|lunch|dinner/i],
 ['門票',/門票|入場|展覽|博物館|美術館|遊樂園|票券|ticket|museum/i],
 ['購物',/購物|伴手禮|藥妝|衣服|服飾|百貨|超市|紀念品|買|shopping|souvenir/i],
];

export function suggestExpenseCategory(title:string,history:Expense[],available:string[]){
 const clean=normalize(title.trim());if(!clean)return {category:'',source:'' as const};
 const match=history.find(expense=>normalize(expense.title)===clean&&available.includes(expense.category));
 if(match)return {category:match.category,source:'history' as const};
 const clue=clues.find(([category,pattern])=>available.includes(category)&&pattern.test(title));
 return clue?{category:clue[0],source:'keyword' as const}:{category:'',source:'' as const};
}

type ParseOptions={defaultCurrency:string;today:string;tripYear:number;history:Expense[];categories:string[]};
const currencyPattern=/韓元|ウォン|KRW|₩|(?<![A-Za-z])W(?=\d)|日圓|日幣|JPY|円|¥|新台幣|台幣|TWD|NT\$|美元|USD|US\$/i;
const paymentPattern=/刷卡|信用卡|卡片|現金|行動支付|電子支付|Apple\s*Pay|Google\s*Pay|PayPay|轉帳|匯款/i;
const numberPattern=/(?:NT\$|US\$|₩|¥|W)?\s*(\d[\d,]*(?:\.\d+)?)(?:\s*(?:韓元|ウォン|KRW|日圓|日幣|JPY|円|新台幣|台幣|TWD|元|美元|USD))?/gi;
const padded=(value:number)=>String(value).padStart(2,'0');
const validDate=(year:number,month:number,day:number)=>{const date=new Date(year,month-1,day);return date.getFullYear()===year&&date.getMonth()===month-1&&date.getDate()===day?`${year}-${padded(month)}-${padded(day)}`:''};

export function parseQuickExpense(raw:string,{defaultCurrency,today,tripYear,history,categories}:ParseOptions){
 let rest=raw.trim();let date=today;
 const relative=rest.match(/^(今天|今日|昨天|昨日)\s*/);
 if(relative){if(relative[1]==='昨天'||relative[1]==='昨日'){const day=new Date(`${today}T12:00:00`);day.setDate(day.getDate()-1);date=`${day.getFullYear()}-${padded(day.getMonth()+1)}-${padded(day.getDate())}`}rest=rest.slice(relative[0].length)}
 else{
  const full=rest.match(/^(20\d{2})[年/.-](\d{1,2})[月/.-](\d{1,2})日?\s*/);
  const short=!full&&rest.match(/^(\d{1,2})[月/.-](\d{1,2})日?\s*/);
  if(full){const found=validDate(Number(full[1]),Number(full[2]),Number(full[3]));if(found){date=found;rest=rest.slice(full[0].length)}}
  else if(short){const found=validDate(tripYear,Number(short[1]),Number(short[2]));if(found){date=found;rest=rest.slice(short[0].length)}}
 }
 const payment=rest.match(paymentPattern);let paymentMethod='';
 if(payment){paymentMethod=/現金/.test(payment[0])?'現金':/刷卡|信用卡|卡片/.test(payment[0])?'信用卡':/轉帳|匯款/.test(payment[0])?'轉帳':'行動支付';rest=rest.replace(payment[0],' ')}
 const explicit=rest.match(currencyPattern)?.[0]||'';
 const currency=/韓元|ウォン|KRW|₩|^W$/i.test(explicit)?'KRW':/日圓|日幣|JPY|円|¥/i.test(explicit)?'JPY':/新台幣|台幣|TWD|NT\$/i.test(explicit)?'TWD':/美元|USD|US\$/i.test(explicit)?'USD':defaultCurrency;
 const amounts=[...rest.matchAll(numberPattern)];const found=amounts.at(-1);const amount=found?Number(found[1].replaceAll(',','')):NaN;
 if(found)rest=rest.slice(0,found.index)+rest.slice((found.index||0)+found[0].length);
 const title=rest.replace(currencyPattern,' ').replace(/\s+/g,' ').trim();
 const recommendation=suggestExpenseCategory(title,history,categories);
 return {title,amount,currency,paymentMethod,date,category:recommendation.category,categorySource:recommendation.source,valid:Boolean(title)&&Number.isFinite(amount)&&amount>0};
}
